import React, { useState, useEffect, useContext } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import clockwhite from "../assets/images/icons/clock-white.svg";
import '../assets/css/Style.css';
import { getApiService } from "../services/ApiService";
import { LanguageContext } from "../contexts/LanguageContext";
import { Spinner, Modal } from "react-bootstrap";
import { GetPayLoad } from "../services/PayLoadStorage";
import Schedulepayment from "../components/schedulepayment";
import Cookies from 'js-cookie';
import { handleFiservLogin } from "../services/FiservLoginService";

const RecentBilling = ({ onApiComplete }) => {

    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    
    const [isLoading, setLoading] = useState(true);
    const [recentBilling, setRecentBilling] = useState([]);
    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);
    const [payNow, setPayNow] = useState(false);
    const [dueDateDays, setDueDateDays] = useState(0);
    const [readOnlyMode, setReadOnlyMode] = useState(false);

    const columns = [
        overViewContent?.overview_recent_billing_last_payment,
        overViewContent?.overview_recent_billing_due,
        overViewContent?.overview_recent_billing_due_date,
        overViewContent?.overview_recent_billing_current_bill,
        overViewContent?.overview_recent_billing_paid_thru,
        overViewContent?.overview_recent_billing_pay_calander,
        overViewContent?.overview_recent_billing_final_bill,
        overViewContent?.overview_recent_billing_action
    ]

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
    }, [pageContent]);

    useEffect(() => {

        // Check for read-only mode based on owning carrier or any other condition
        setReadOnlyMode(Payload?.readOnlyAccess === true);
         
        const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region"   : Payload?.region
        };
        const targetBillingDetailsUrl = process.env.REACT_APP_API_CASE_BILL_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetBillingDetailsUrl, { cim: Payload?.cim, apiSource: 'recentBilling' }, headers)
            .then((response) => {

                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    setErrorFlag(false);
                    const result = response.data.data;
                    setRecentBilling(result);
                    setDueDateDays(result?.DueDateDays || 0);
                }
                if (onApiComplete) onApiComplete();
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
                if (onApiComplete) onApiComplete();
            });

    }, [Payload?.cim, baseUrl, Payload?.region]);

    const handlePayNow = (e) => {
        e.preventDefault();
        if(Cookies.get('owningCarrier') !== 'C4') {
            setPayNow(true);
        }
        // For Fiserv (C4), handle login in a new tab
        if(Cookies.get('owningCarrier') === 'C4') {
            handleFiservLogin();
        }
    }

    const handleCloseSchedulePaymentModal = (e) => {
        e.preventDefault();
        setPayNow(false);
    }

    const dueDaysContent = Number(dueDateDays) > 0 ? overViewContent?.overview_recent_billing_duedate_text : overViewContent?.overview_topay_pastdue_days_text;
    let dueDaysModifiedContent = dueDaysContent ? (Number(dueDateDays) > 0 ? dueDaysContent.replace(/{{DueDateDays}}/g, dueDateDays) : dueDaysContent.replace("%s", Math.abs(dueDateDays))): '';
    
    return (
        <>
            {errorFlag && (
                <div className="api-error-msg">
                    {genericContent?.finance_service_error}
                </div>
            )}
            {isLoading && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                    <Spinner animation="border" role="status" ></Spinner>
                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                </div>
            )}
            {!isLoading && !errorFlag && recentBilling && (
                <div className="bd-example table-responsive billing-tables">
                    <table className="table table-striped" style={{ marginLeft: '' }}>
                        <caption style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: '0' }}>
                            {overViewContent?.overview_recent_billing_title}
                        </caption>
                        <thead className="billing-thead">
                            <tr>
                                {
                                    columns && columns?.map((item) => <th scope="col" className="recentbilling">{item}</th>)
                                }
                            </tr>
                        </thead>
                        <tbody className="billing-tbody">
                            <tr className="billing-row">
                                <td className="recentbilling">{recentBilling?.LastPaymentRecvd}</td>
                                <td className="recentbilling">{recentBilling?.CurrentDueAmount}</td>
                                <td className="recentbilling"><span>{recentBilling?.DueDate}</span><br></br>
                                    {/* st48236 - Show message after payment is done - BA raised request - due amount condition checking */}
                                    {recentBilling?.DueDate !== 'N/A' && dueDateDays !== '' && (parseFloat(recentBilling?.CurrentDueAmount?.replace('$', '')) > 0) && (
                                        Payload?.owning_carrier === 'Q5' ? (
                                            <span className="text-primary">
                                                <i class="fe fe-clock navy-icon"></i> 
                                                {" " + dueDaysModifiedContent}
                                            </span>
                                        ) : 
                                            <button className="btn btn-danger btn-sm rounded-pill due-date-btn">
                                                <img src={clockwhite} alt="clock" />
                                                {dueDaysModifiedContent}
                                            </button>
                                    )}
                                </td>
                                <td className="recentbilling">{recentBilling?.CurrentBillPeriod}</td>
                                <td className="recentbilling">{recentBilling?.PaidThruDate}</td>
                                <td className="recentbilling">{recentBilling?.PayCalendar}</td>
                                <td className="recentbilling">{recentBilling?.FinalBillRunDate}</td>
                                <td className="recentbilling">
                                    {!readOnlyMode ? (
                                    <button className="btn btn-primary paynowbutton" onClick={handlePayNow}>
                                        {overViewContent?.overview_paynow_button_text}
                                    </button>
                                    ) : (<span>NA</span>)
                                    }
                                    {payNow && (<Modal size='xl' show={payNow} onHide={() => { setPayNow() }} className="schedulepayment">
                                        <Schedulepayment handleCloseSchedulePaymentModal={handleCloseSchedulePaymentModal} />
                                        </Modal>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </>
    )
}

export default RecentBilling;